import { AbilitySlot } from '../atoms/AbilitySlot';

/**
 * Mobile/desktop ability bar — Q (attack), E (dash), W (block), R (potion).
 * Shows cooldown overlays and ready-state styling.
 * Props: attackCdProg, dashCdProg, blockCdProg, potionCdProg, potionCount, isDashing,
 *        onMobileAttack, onMobileDash, onMobileBlock, onMobilePotion
 */
export function AbilityBar({ attackCdProg, dashCdProg, blockCdProg, potionCdProg, potionCount, isDashing, onMobileAttack, onMobileDash, onMobileBlock, onMobilePotion }) {
  const potionReady        = potionCdProg >= 1 && potionCount > 0;
  const potionCdProgActual = potionCount > 0 ? potionCdProg : 0;

  return (
    <div className="ability-bar">
      <AbilitySlot cdProg={attackCdProg} glyph="⚔️" keyLabel="Q" onClick={onMobileAttack} />
      <AbilitySlot cdProg={dashCdProg}   glyph="💨" keyLabel="E" isActive={isDashing} onClick={onMobileDash} />
      <AbilitySlot cdProg={blockCdProg}  glyph="🛡️" keyLabel="W" onClick={onMobileBlock} />

      {/* R — HP Potion: extra class and count badge */}
      <AbilitySlot
        cdProg={potionCdProgActual}
        glyph="🧪"
        keyLabel="R"
        isReady={potionReady}
        className={`ability-icon--potion${potionCount <= 0 ? ' ability-icon--empty' : ''}`}
        onClick={onMobilePotion}
      >
        {potionCount > 0 && (
          <span className="ability-potion-count">{potionCount}</span>
        )}
      </AbilitySlot>
    </div>
  );
}
